import { Routes } from '@angular/router';
import { LoginComponent } from '@cosmos/angular/ui';
import { ResetGuard } from '@cosmos/angular/utils';
import { PasswordRecoveryComponent } from '@cosmos/angular/ui';
import { PasswordResetComponent } from '@cosmos/angular/ui';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'recovery', component: PasswordRecoveryComponent },
  {
    path: 'reset',
    canActivate: [ResetGuard],
    component: PasswordResetComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(
        (dashboard) => dashboard.dashboardRoutes,
      ),
  },
  { path: '**', redirectTo: '' },
];
